import React, { Component } from 'react';
import { connect } from 'react-redux';
import history from '../../helpers/history';

// 引入 ECharts 主模块
import echarts from 'echarts/lib/echarts';
import 'echarts-gl';

// 引入柱状图
import "echarts/lib/chart/bar";

// 引入提示框和标题组件
import "echarts/lib/component/tooltip";
import 'echarts/lib/component/title';
import 'echarts/lib/chart/line';
import 'echarts/lib/chart/scatter';//effectScatter
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/axisPointer';
import 'echarts/lib/component/markArea';
import 'echarts/lib/component/legendScroll';

import { Layout, Table, Divider, Button, message, Select, Spin, Modal, Form, DatePicker } from 'antd';
import { getChartOption } from './chartOptions/index';

import emitter from '../Evt.js';

import moment from 'moment';
var moment_timezone = require('moment-timezone');

const { Content } = Layout;
var languageMessages = window.appLocale.messages;

var wts = {
    'sName': 'wT',
    'xData': [],
    'data': []
};

function strReplace(source, jsonObjcet) {
    for (var v in jsonObjcet) {
        source = source.replace(v, jsonObjcet[v]);
    }
    return source;
}

var colors = ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc'];

function guid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

class PortfolioOptResult extends Component {
    constructor(props) {
        super(props);

        window.webType === 'US' ? moment_timezone.tz.setDefault("America/New_York") : moment_timezone.tz.setDefault("Asia/Shanghai");

        this.charts = {
            "wt": null
        }
        
        this.state = {
            spinLoadding: true,

            statisticsResult: [],

            portfolioId: 0,
            portfolioDataSource: [],
            backtsetDataSource: [],
            dataSource: [],

            startDate: moment().add(-90, 'days').format('YYYY-MM-DD'),
            endDate: moment().add(-1, 'days').format('YYYY-MM-DD'),

            endOpen: false,

            modalTitle: '',
            modalVisible: false,

            tradeDateStatus: '',
            tradeDateMessage: '',

            isStartBacktest: false,

            isShowBacktestInfo: false,
        }
    }
    
    componentDidMount() {
        const { statisticsResult } = this.props;
        
        this.setBacktestResult(statisticsResult);
        
    }

    setBacktestResult(statisticsResult) {

        this.charts = {
            "wt": null
        };
        
        wts.xData = [];
        wts.data = [];

        var portfolioId = 0
        var portfolioDataSource = [];

        if (statisticsResult.portfolioOptResult != null && statisticsResult.portfolioOptResult.length > 0) {
            portfolioId = statisticsResult.portfolioId;
            var portfolioOptResult = statisticsResult.portfolioOptResult;
            
            var index = 1;
            for (var ii in portfolioOptResult) {
                portfolioDataSource.push({
                    key: index,//trades[item].backtestId,
                    section: portfolioOptResult[ii].S,
                    maximizing: portfolioOptResult[ii].R,
                    minimize: portfolioOptResult[ii].V,
                    benchmarking: portfolioOptResult[ii].B,
                });
                

                var wtData = [];
                
                var wT = portfolioOptResult[ii].wT;
                for (let key in wT) {
                    wtData.push(wT[key]);

                    if(index == 1) wts.xData.push(key);
                }
                
                wts.data.push({ 'data': wtData, 'name': portfolioOptResult[ii].S });

                index++;
            }
        }
        this.setWtData("wt", wts);

        this.setState({ portfolioId, portfolioDataSource, statisticsResult });
    }

    componentWillUnmount() {
    }

    resizeChart() {
        var wtChart = this.charts['wt'];
        
        window.onresize = function () {
            if (wtChart != null) wtChart.resize();
        }
    }

    setWtData(chartName, chartData) {
        this.charts[chartName] = echarts.init(document.getElementById(chartName));
        this.charts[chartName].setOption(getChartOption(chartName, chartData));

        this.charts[chartName].resize();

        this.resizeChart();
    }

    keepDecimals(value, sign) {
        value = value == null ? '' : value;
        if (value !== '') {
            //value = value.replace(/([0-9]+.[0-9]{2})[0-9]*/, "$1");
            value = Number(value).toFixed(2);
            value += sign;
        }

        return value;
    }

    componentWillReceiveProps(props) {
        var { status, statisticsResult } = props;
        
        switch (status) {
            default:
                if (this.state.statisticsResult == statisticsResult) return;

                this.setBacktestResult(statisticsResult);
                break;
        }
    }

    onStartBacktest = () => {
        window._hmt && window._hmt.push(['_trackEvent', 'Portfolio backtest', 'Portfolio backtest', 'Portfolio backtest']);

        this.setState({
            modalTitle: languageMessages['stockBacktest'],
            modalVisible: true,
            
        });
    }

    //开始日期
    onChangeStartDate = startDate => {
        startDate = moment(startDate).format("YYYY-MM-DD");

        //判断小于结束时间
        /** 
        var oDate1 = new Date(startDate);
        var oDate2 = new Date(endDate);
        if (oDate1.getTime() < oDate2.getTime()) {
            
        }
        */

        this.setState({ startDate });
    }

    //结束日期
    onChangeEndDate = endDate => {
        endDate = moment(endDate).format("YYYY-MM-DD");

        var tradeDateStatus = '';
        var tradeDateMessage = '';

        var oDate1 = new Date(this.state.startDate);
        var oDate2 = new Date(endDate);

        var intDate1 = oDate1.getTime();
        var intDate2 = oDate2.getTime();
        if (intDate1 > intDate2) {
            tradeDateStatus = 'error';
            tradeDateMessage = languageMessages['startDateGreaterThanEndDate'];
        }

        this.setState({ endDate, tradeDateStatus, tradeDateMessage });
    }

    todayDisabledDate = current => {
        const { endDate } = this.state;
        if (!endDate) {
            return false;
        }
        return current && (current > moment(endDate) || current < moment(endDate).add(-6, 'months'));
    }

    endDisabledDate = current => {
        const { startDate } = this.state;
        if (!startDate) {
            return false;
        }
        return current && (current < moment(startDate) || current > moment().add(-1, 'days'));
    }

    handleStartOpenChange = open => {
        if (!open) {
            this.setState({ endOpen: true });
        }
    };

    handleEndOpenChange = endOpen => {
        var tradeDateStatus = '';
        var tradeDateMessage = '';

        if (!endOpen) {
            //判断日期是否小于开始日期
            var oDate1 = new Date(this.state.startDate);
            var oDate2 = new Date(this.state.endDate);

            var intDate1 = oDate1.getTime();
            var intDate2 = oDate2.getTime();
            if (intDate1 > intDate2) {
                tradeDateStatus = 'error';
                tradeDateMessage = languageMessages['startDateGreaterThanEndDate'];
            }
        }

        this.setState({ endOpen, tradeDateStatus, tradeDateMessage });
    };

    renderModalContent() {
        return <div style={{ marginBottom: '20px' }}>
            <Form labelAlign={'left'} layout="inline" className={window.webType === 'US' ? 'common-form-hawkeye hawkeye-us' : 'common-form-hawkeye'}>
                <Form.Item colon={false} label={languageMessages['backtestInterval']} validateStatus={this.state.tradeDateStatus} help={this.state.tradeDateMessage}>
                    <span style={{ display: 'inline-block' }}>
                        <DatePicker size="small"
                            allowClear={false}
                            placeholder={languageMessages['pleaseEnterStartDate']}
                            value={moment(this.state.startDate, "YYYY-MM-DD")}
                            disabledDate={this.todayDisabledDate}
                            format={"YYYY-MM-DD"} style={{ width: '120px' }}
                            onChange={this.onChangeStartDate}
                            onOpenChange={this.handleStartOpenChange}
                        />
                    </span>
                    <span style={{ display: 'inline-block', width: '24px', textAlign: 'center' }}>{languageMessages['intl.to']}</span>
                    <span style={{ display: 'inline-block' }}>
                        <DatePicker size="small"
                            allowClear={false}
                            placeholder={languageMessages['pleaseEnterEndDate']}
                            value={moment(this.state.endDate, "YYYY-MM-DD")}
                            disabledDate={this.endDisabledDate}
                            format={"YYYY-MM-DD"} style={{ width: '120px' }}
                            onChange={this.onChangeEndDate}
                            disabled={this.state.startDate === ''}
                            open={this.state.endOpen}
                            onOpenChange={this.handleEndOpenChange}
                        />
                    </span>
                </Form.Item>
            </Form>
        </div>
    }

    handleOk = e => {
        var user = JSON.parse(sessionStorage.getItem("auth") || '{}') || {};
        if (user.username === undefined) {
            this.props.dispatch({ type: "action_non_user" });
        } else {
            let { portfolioId, startDate, endDate } = this.state;

            this.setState({ modalVisible: false, isStartBacktest: true }, () => {
                this.props.dispatch({
                    type: "action_send_hub_message", payload: {
                        service: 'StartPortfolioOptBacktest', userId: this.user.username,
                        msg: {
                            p: portfolioId,
                            f: startDate,
                            t: endDate
                        }
                    }
                });
            });
        }
    }

    handleCancel = e => {
        this.setState({ modalVisible: false, isStartBacktest: false });
    }

    render() {
        var { portfolioDataSource, backtestDataSource, dataSource } = this.state;

        const portfolioColumns = [
            {
                title: 'Section',
                dataIndex: 'section',
                align: 'center',
                //width: 200
            }, {
                title: languageMessages['Maximizing returns'],
                dataIndex: 'maximizing',
                align: 'right',
                sorter: (a, b) => a.maximizing - b.maximizing,
                sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['Minimize variance'],
                dataIndex: 'minimize',
                align: 'right',
                sorter: (a, b) => a.minimize - b.minimize,
                sortDirections: ['descend', 'ascend'],
                //width: 50
            }, {
                title: languageMessages['Benchmarking income'],
                dataIndex: 'benchmarking',
                //fixed: 'right',
                align: 'right',
                sorter: (a, b) => a.benchmarking - b.benchmarking,
                sortDirections: ['descend', 'ascend'],
            }
        ];

        const backtsetColumns = [
            {
                title: languageMessages['sequence'],
                dataIndex: 'sequence',
                align: 'center',
                width: 50
            }, {
                title: languageMessages['created'],
                dataIndex: 'created',
                width: 135,
                sorter: (a, b) => a.created - b.created,
                sortDirections: ['descend', 'ascend']
            }, {
                title: languageMessages['fromDate'],
                dataIndex: 'fromDate',
                width: 90,
                sorter: (a, b) => a.fromDate - b.fromDate,
                sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['toDate'],
                dataIndex: 'toDate',
                width: 90,
                sorter: (a, b) => a.toDate - b.toDate,
                sortDirections: ['descend', 'ascend'],
            },

            /**
            {
                title: languageMessages['control'],
                dataIndex: 'operation',
                //fixed: 'right',
                width: 100,
                render: (text, record) => {
                    return <Button size='small' onClick={() => this.handleViewPortfolioResult(record)}>{languageMessages['view']}</Button>
                }
            }
            */
        ];

        const columns = [
            {
                title: languageMessages['sequence'],
                dataIndex: 'sequence',
                align: 'right',
                width: 50
            }, {
                title: languageMessages['symbolCode'],
                dataIndex: 'symbolName',
                //sorter: (a, b) => a.symbolName < b.symbolName ? -1 : a.symbolName > b.symbolName ? 1 : 0,
                //sortDirections: ['descend', 'ascend'],
                //render: (text, record) => <a onClick={() => this.selectRow(record)}>{text}</a>,
            }, {
                title: languageMessages['direction'],
                dataIndex: 'direction',
                //sorter: (a, b) => a.direction < b.direction ? -1 : a.direction > b.direction ? 1 : 0,
                //sortDirections: ['descend', 'ascend'],
                render: (text, record) => (
                    <span>
                        {languageMessages.hasOwnProperty(record.direction) ? languageMessages[record.direction] : record.direction}
                    </span>
                )
            }, {
                title: languageMessages['tradeTimes'],
                dataIndex: 'tradeTime',
                //sorter: (a, b) => a.tradeTimes - b.tradeTimes,
                //sortDirections: ['descend', 'ascend']
            }, {
                title: languageMessages['strikePrice'],
                dataIndex: 'strikePrice',
                align: 'right',
                //sorter: (a, b) => a.strikePrice - b.strikePrice,
                //sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['tradeSize'],
                dataIndex: 'volume',
                align: 'right',
                //sorter: (a, b) => a.volume - b.volume,
                //sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['dollars'],
                dataIndex: 'turnover',
                align: 'right',
                //sorter: (a, b) => a.turnover - b.turnover,
                //sortDirections: ['descend', 'ascend'],
            }, {
                title: languageMessages['pnls'],
                dataIndex: 'pnl',
                align: 'right',
                //sorter: (a, b) => a.pnl - b.pnl,
                //sortDirections: ['descend', 'ascend'],
                render: (text, row, index) => {
                    if (row['pnl'] !== '' && row['pnl'] >= 0) {
                        return <span style={{ color: window.webType === 'US' ? 'green' : 'red' }}>{text}</span>;
                    } else {
                        return <span style={{ color: window.webType === 'US' ? 'red' : 'green' }}>{text}</span>;
                    }
                }
            }, {
                title: languageMessages['gain'] + '(%)',
                dataIndex: 'pnlp',
                align: 'right',
                //sorter: (a, b) => a.pnlp - b.pnlp,
                //sortDirections: ['descend', 'ascend'],
                render: (text, row, index) => {
                    if (row['pnlp'] !== '' && row['pnlp'] >= 0) {
                        return <span style={{ color: window.webType === 'US' ? 'green' : 'red' }}>{text}</span>;
                    } else {
                        return <span style={{ color: window.webType === 'US' ? 'red' : 'green' }}>{text}</span>;
                    }
                }
            }
        ];

        return (<Content>
            <Spin spinning={this.state.spinLoadding}>
                <div className='common-title'><Divider type="vertical" />{languageMessages['Portfolio opt info']}</div>

                <Table bordered size='small' locale={{ emptyText: ' ' }}
                    columns={portfolioColumns}
                    dataSource={portfolioDataSource} pagination={false} />

                <div id="wt" style={{ height: "500px", marginTop: "20px" }} > </div>

                <div className='common-title'><Divider type="vertical" />{languageMessages['backtestItems']}</div>
                <Table bordered size='small' locale={{ emptyText: ' ' }}
                    columns={backtsetColumns}
                    dataSource={backtestDataSource} pagination={false} />

                <Button size='small' onClick={this.onStartBacktest}>{languageMessages['startBacktest']}</Button>

                <div style={{ display: this.state.isShowBacktestInfo ? '' : 'none' }}>
                    <div className='common-title'><Divider type="vertical" />{languageMessages['fundsCurve']}</div>
                    <div id="income" style={{ height: "500px", marginTop: "20px" }} > </div>

                    <div className='common-title'><Divider type="vertical" />{languageMessages['tradeDetails']}</div>
                    <Table bordered size='small' locale={{ emptyText: ' ' }} columns={columns} dataSource={dataSource} pagination={dataSource.length >= 40 ? { pageSize: 40 } : false} />
                </div>
            </Spin>

            <Modal
                title={this.state.modalTitle}
                visible={this.state.modalVisible}
                maskClosable={false}
                onOk={this.handleOk}
                confirmLoading={this.state.isStartBacktest}
                onCancel={this.handleCancel}>
                {this.renderModalContent()}
            </Modal>
            
        </Content>);
    }
}

export { PortfolioOptResult as default }
